__webpack_public_path__ = '/front_assets/'; // eslint-disable-line

Number.isNaN = Number.isNaN || function isNaNPolyfill(value) {
  return value !== value; // eslint-disable-line no-self-compare
};

const token = document.head.querySelector('meta[name="csrf-token"]').content;

$.ajaxSetup({
  beforeSend: (xhr) => {
    xhr.setRequestHeader('X-CSRF-TOKEN', token);
  },
});

$('input#alternative_working_address[type=checkbox]').click(() => {
  const workingAddressWrapper = $('#working-address-wrapper');
  if (workingAddressWrapper.css('display') === 'block') {
    workingAddressWrapper.hide('fast');
  } else {
    workingAddressWrapper.show('fast');
  }
});
